import './style.scss';
import React from 'react';

function displayClass({ inline, inlineBlock }) {
  if (inline) return 'view--inline';
  if (inlineBlock) return 'view--inline-block';
}

function paddingClass(padding) {
  return typeof padding === 'object'
    ? paddingSidesClass(padding)
    : paddingAllClass(padding);
}

function paddingSidesClass(padding) {
  const left = padding.left || padding.sides || '';
  const right = padding.right || padding.sides || '';
  const top = padding.top || '';
  const bottom = padding.bottom || '';
  return [
    paddingTopClass(top),
    paddingLeftClass(left),
    paddingRightClass(right),
    paddingBottomClass(bottom)
  ]
    .filter(c => !!c)
    .join(' ');
}

function paddingAllClass(padding) {
  switch (padding) {
    case 'xs':
      return 'view--padding-xs';
    case 'sm':
      return 'view--padding-sm';
    case 'md':
      return 'view--padding-md';
    case 'lg':
      return 'view--padding-lg';
    case 'xl':
      return 'view--padding-xl';
    default:
      return '';
  }
}

function paddingTopClass(padding) {
  switch (padding) {
    case 'xs':
      return 'view--padding-top-xs';
    case 'sm':
      return 'view--padding-top-sm';
    case 'md':
      return 'view--padding-top-md';
    case 'lg':
      return 'view--padding-top-lg';
    case 'xl':
      return 'view--padding-top-xl';
    default:
      return '';
  }
}

function paddingLeftClass(padding) {
  switch (padding) {
    case 'xs':
      return 'view--padding-left-xs';
    case 'sm':
      return 'view--padding-left-sm';
    case 'md':
      return 'view--padding-left-md';
    case 'lg':
      return 'view--padding-left-lg';
    case 'xl':
      return 'view--padding-left-xl';
    default:
      return '';
  }
}

function paddingRightClass(padding) {
  switch (padding) {
    case 'xs':
      return 'view--padding-right-xs';
    case 'sm':
      return 'view--padding-right-sm';
    case 'md':
      return 'view--padding-right-md';
    case 'lg':
      return 'view--padding-right-lg';
    case 'xl':
      return 'view--padding-right-xl';
    default:
      return '';
  }
}

function paddingBottomClass(padding) {
  switch (padding) {
    case 'xs':
      return 'view--padding-bottom-xs';
    case 'sm':
      return 'view--padding-bottom-sm';
    case 'md':
      return 'view--padding-bottom-md';
    case 'lg':
      return 'view--padding-bottom-lg';
    case 'xl':
      return 'view--padding-bottom-xl';
    default:
      return '';
  }
}

function marginClass(margin) {
  switch (margin) {
    case 'xxs':
      return 'view--margin-xxs';
    case 'xs':
      return 'view--margin-xs';
    case 'sm':
      return 'view--margin-sm';
    case 'md':
      return 'view--margin-md';
    case 'lg':
      return 'view--margin-lg';
    case 'xl':
      return 'view--margin-xl';
    default:
      return '';
  }
}

export default function View(props) {
  const Tag = props.tag || 'div';
  const children = props.children || null;
  const id = props.id || null;

  const className =
    [
      props.className || '',
      displayClass(props),
      paddingClass(props.padding),
      marginClass(props.margin)
    ]
      .filter(c => !!c)
      .join(' ') || null;

  return (
    <Tag className={className} id={id}>
      {children}
    </Tag>
  );
}



// WEBPACK FOOTER //
// ./shared/components/ui/view/index.js